export default {
    api_server_url: process.env.VUE_APP_BE_API_URL,
    fe_url: process.env.VUE_APP_FE_API_URL,
	id_number: 1
}
